//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SiteStartDrawer from "./modules/SiteStartDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import { downloadFile } from '@/api/manage';
export default {
  name: 'SiteStopList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    SiteStartDrawer: SiteStartDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/site/start',
      pageTitle: '复运申请',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'siteName',
        colName: 'siteName',
        title: '站点名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'userId',
        title: '申请人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'stopReason_dictText',
        colName: 'stopReason',
        title: '停运原因',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'instrument',
        colName: 'instrument',
        title: '仪器型号',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '复运标题',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'startTime',
        colName: 'start_time',
        title: '复运时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'nextStatus',
        colName: 'nextStatus',
        title: '当前审批状态',
        align: 'center',
        scopedSlots: {
          customRender: 'nextStatus'
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      addDisabled: false,
      userTree: []
    };
  },
  created: function created() {
    this.queryUserTreeList();
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      console.log('value11', value);
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        console.log('this.siteColumn', this.siteColumn);
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    // onDateStopTime: function (value, dateArray) {
    //   this.queryParam.timeStart = dateArray[0]
    //   this.queryParam.timeEnd = dateArray[1]
    // },
    onDateStartTime: function onDateStartTime(value, dateArray) {
      this.queryParam.timeStart = dateArray[0];
      this.queryParam.timeEnd = dateArray[1];
    },
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
    },
    // 获取运维人员树
    queryUserTreeList: function queryUserTreeList() {
      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }
        }
      });
    },
    onToPdf: function onToPdf(record) {
      console.log('record', record);
      downloadFile(record.siteName + '复运申请.pdf', window.domainURL + '/om/site/start/exportPdf?id=' + record.id, {});
    }
  }
};